import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Dialog, DialogContent } from './ui/dialog';
import { Play, X } from 'lucide-react';

const Gallery = () => {
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  // Placeholder data - Replace with your actual customer photos and videos
  const galleryItems = [
    {
      id: 1,
      type: 'video',
      thumbnail: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=600&h=400&fit=crop',
      videoUrl: '/customer-testimonial.mp4',
      title: 'Happy Customer Testimonial',
      customer: 'Satisfied Customer - Varun Solar'
    },
    {
      id: 2,
      type: 'image',
      url: 'https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?w=600&h=400&fit=crop',
      title: 'Commercial Solar Project',
      customer: 'Happy Customer 2'
    },
    {
      id: 3,
      type: 'image',
      url: 'https://images.unsplash.com/photo-1497440001374-f26997328c1b?w=600&h=400&fit=crop',
      title: 'Solar Atta Chakki Installation',
      customer: 'Happy Customer 3'
    },
    {
      id: 4,
      type: 'image',
      url: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=600&h=400&fit=crop',
      title: 'Rooftop Solar Panel Setup',
      customer: 'Happy Customer 4'
    },
    {
      id: 5,
      type: 'image',
      url: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=400&fit=crop',
      title: 'Installation Process',
      customer: 'Project Showcase'
    },
    {
      id: 6,
      type: 'image',
      url: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=600&h=400&fit=crop',
      title: 'Happy Customer with Solar System',
      customer: 'Happy Customer 5'
    },
    {
      id: 7,
      type: 'image',
      url: 'https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?w=600&h=400&fit=crop',
      title: 'Solar Installation Complete',
      customer: 'Happy Customer 6'
    },
    {
      id: 8,
      type: 'image',
      url: 'https://images.unsplash.com/photo-1559302504-64aae6ca6b6d?w=600&h=400&fit=crop',
      title: 'Solar Energy System',
      customer: 'Happy Customer 7'
    }
  ];

  const openMedia = (item) => {
    setSelectedMedia(item);
    setIsOpen(true);
  };

  const closeMedia = () => {
    setIsOpen(false);
    setSelectedMedia(null);
  };

  return (
    <section id="gallery" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Happy Customers & Projects
          </h2>
          <p className="text-lg text-gray-600">
            See how we've transformed homes and businesses with clean solar energy
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {galleryItems.map((item) => (
            <Card
              key={item.id}
              className="relative border-none shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group cursor-pointer overflow-hidden"
              onClick={() => openMedia(item)}
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={item.type === 'image' ? item.url : item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                
                {/* Video Play Button Overlay */}
                {item.type === 'video' && (
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center group-hover:bg-black/50 transition-colors">
                    <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                      <Play className="w-8 h-8 text-green-600 ml-1" />
                    </div>
                  </div>
                )}

                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                {/* Title Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-4 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <h3 className="font-bold text-sm mb-1">{item.title}</h3>
                  <p className="text-xs text-gray-200">{item.customer}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <button
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="bg-gradient-to-r from-lime-500 to-green-600 hover:from-lime-600 hover:to-green-700 text-white font-semibold px-8 py-4 rounded-lg transition-all duration-300 hover:scale-105 hover:shadow-xl"
          >
            Join Our Happy Customers
          </button>
        </div>
      </div>

      {/* Modal for Full View */}
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="max-w-4xl w-full p-0 bg-black">
          <button
            onClick={closeMedia}
            className="absolute top-4 right-4 z-50 w-10 h-10 bg-white/90 hover:bg-white rounded-full flex items-center justify-center transition-all"
          >
            <X className="w-6 h-6 text-gray-900" />
          </button>
          
          {selectedMedia && (
            <div className="relative">
              {selectedMedia.type === 'image' ? (
                <img
                  src={selectedMedia.url}
                  alt={selectedMedia.title}
                  className="w-full h-auto"
                />
              ) : (
                <div className="relative bg-black">
                  <video
                    src={selectedMedia.videoUrl}
                    controls
                    autoPlay
                    className="w-full h-auto"
                  >
                    Your browser does not support the video tag.
                  </video>
                </div>
              )}
              <div className="bg-white p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{selectedMedia.title}</h3>
                <p className="text-gray-600">{selectedMedia.customer}</p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default Gallery;
